import {
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Box,
  Typography,
  Button,
  Chip,
  Stack,
} from "@mui/material";
import StarRoundedIcon from "@mui/icons-material/StarRounded";
import SportsEsportsOutlinedIcon from "@mui/icons-material/SportsEsportsOutlined";

type GameCardProps = {
  title: string;
  subtitle: string;
  coverSrc: string;
  iconSrc?: string;
  rating?: number;
  gamePseudo: string;
  ctaLabel?: string;
  onPlayClick?: (pseudo: string) => void;
};

export function GameCard({
  title,
  subtitle,
  coverSrc,
  iconSrc,
  rating = 0,
  gamePseudo,
  ctaLabel = "",
  onPlayClick,
}: GameCardProps) {
  const CTA = (
    <Button
      onClick={() => onPlayClick?.(gamePseudo)}
      rel="noopener noreferrer"
      variant="contained"
      endIcon={<SportsEsportsOutlinedIcon />}
      sx={{ borderRadius: "9999px", px: 3, fontWeight: 700 }}
    >
      {ctaLabel}
    </Button>
  );

  return (
    <Card
      elevation={0}
      sx={{
        width: "100%",
        borderRadius: 3,
        overflow: "hidden",
        bgcolor: "transparent",
        position: "relative",
      }}
    >
      <CardActionArea component="div" disableRipple>
        <Box sx={{ position: "relative" }}>
          <CardMedia
            component="img"
            image={coverSrc}
            alt={title}
            sx={{
              height: 180,
              objectFit: "cover",
              display: "block",
            }}
          />
          <Chip
            icon={<StarRoundedIcon sx={{ fontSize: 18 }} />}
            label={rating.toFixed(1)}
            size="small"
            sx={{
              position: "absolute",
              top: 8,
              left: 8,
              bgcolor: "rgba(255,255,255,0.9)",
              fontWeight: 700,
              "& .MuiChip-icon": { color: "#FFB800" },
            }}
          />
        </Box>
        <CardContent
          sx={{
            p: 2,
            background: "#C026D3",
            color: "#fff",
          }}
        >
          <Stack direction="row" spacing={1.5} alignItems="center">
            {iconSrc && (
              <Box
                component="img"
                src={iconSrc}
                alt={`${title} icon`}
                sx={{
                  width: 42,
                  height: 42,
                  borderRadius: 1.5,
                  objectFit: "cover",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.25)",
                }}
              />
            )}

            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 800, lineHeight: 1.1 }}
                noWrap
                title={title}
              >
                {title}
              </Typography>
              <Typography
                variant="caption"
                sx={{ opacity: 0.9, display: "block" }}
                noWrap
                title={subtitle}
              >
                {subtitle}
              </Typography>
            </Box>
            {CTA}
          </Stack>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
